import { useSelector } from 'react-redux'

import { selectOrderStepIdsInRange } from '@/features/domain/order'

export function useHasOrders() {
  const orderStepsIds = useSelector(selectOrderStepIdsInRange)

  return Object.keys(orderStepsIds).length > 0
}
